export { default } from './JournalArticlesSlider';
